import React from 'react'
import type { Icon } from 'shared/utils'

const Minus = (props: Icon) => {
    const { color = '#BB1E32', size = 24, className = 'minus' } = props
    return (
        <svg className={className} width={size} height={size}>
            <path
                fill={color}
                d="M18.4 11H5.6c-.884 0-1.6.448-1.6 1s.716 1 1.6 1h12.8c.884 0 1.6-.448 1.6-1s-.716-1-1.6-1z"
            />
        </svg>
    )
}

export { Minus }
